export default __webpack_public_path__ + "static/media/quattris-logo.08c86e75.svg";